export const COMPANY_NAME = 'HAITIAN COMMUNITY HELP & SUPPORT CENTER';
export const COMPANY_SHORT = 'Haitian Community Help Center';
export const COMPANY_MONOGRAM = 'HCHSC';
export const COMPANY_ADDRESS_FULL = '1530 S YELLOW SPRINGS ST, SPRINGFIELD, OH 45506-2547';
export const COMPANY_LOCATION = 'Springfield, Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=1530%20S%20YELLOW%20SPRINGS%20ST%2C%20SPRINGFIELD%2C%20OH%2045506-2547';

export const PROFILE_FACTS = [
  { label: 'Profile Type', value: 'Community Help' },
  { label: 'Location', value: COMPANY_LOCATION },
  { label: 'Public Data', value: 'Identifiers excluded' },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Address', value: COMPANY_ADDRESS_FULL },
];

export const SUPPORT_NOTES = [
  {
    number: '01',
    title: 'Unity-focused reference',
    body: 'A concise public page for people looking up the organization, its name, and its Springfield location.',
  },
  {
    number: '02',
    title: 'Source-backed directory data',
    body: 'The page only presents supplied public-facing profile details and avoids unsupported contact or program claims.',
  },
  {
    number: '03',
    title: 'Clear location access',
    body: 'The address is kept visible for directory, partner, and community reference with a direct map link.',
  },
];
